import {useStyles} from '@wix/tpa-settings/react'
import {EventDetailsAlignment} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Tag, TagSize, TagSkin, TextButton, TextButtonPriority} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import stylesParams from '../../../../stylesParams'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {
  getAllOccurrencesCount,
  getMoreOccurrencesCount,
  getUpcomingOccurrencesSuggestions,
  isLastAvailableOccurrence,
} from '../../../selectors/occurrences'
import cs from '../../classnames.scss'
import s from './upcoming-occurrences.scss'
import {classes} from './upcoming-occurrences.st.css'

const LABEL_ID = 'upcoming-occurrences-label'

export const UpcomingOccurrences = () => {
  const {changeEvent, openOccurrencesModal} = useAppActions()
  const occurrencesSuggestions = useAppSelector(getUpcomingOccurrencesSuggestions)
  const moreCount = useAppSelector(getMoreOccurrencesCount)
  const allCount = useAppSelector(getAllOccurrencesCount)
  const isLastOccurrence = useAppSelector(isLastAvailableOccurrence)
  const {t} = useTranslation()
  const contentAlignment = useStyles().get(stylesParams.contentAlignment)

  return (
    <div data-hook={DH.UPCOMING_OCCURRENCES}>
      <div id={LABEL_ID} data-hook={DH.UPCOMING_OCCURRENCES_LABEL} className={cs.textFontAndColor}>
        {isLastOccurrence ? t('recurring.lastAvailableDate') : t('recurring.otherDates')}
      </div>
      {!isLastOccurrence && (
        <div
          role="group"
          aria-labelledby={LABEL_ID}
          className={classNames(s.tagsRow, {
            [s.leftAligned]: contentAlignment === EventDetailsAlignment.LEFT,
            [s.rightAligned]: contentAlignment === EventDetailsAlignment.RIGHT,
          })}
        >
          {occurrencesSuggestions.map((occurrence, index) => (
            <Tag
              key={index}
              data-hook={DH.UPCOMING_OCCURRENCE}
              className={classes.tag}
              size={TagSize.small}
              skin={TagSkin.light}
              onClick={() => changeEvent(occurrence.slug)}
            >
              {occurrence.shortStartDateTime}
            </Tag>
          ))}
          {moreCount > occurrencesSuggestions.length && (
            <TextButton
              data-hook={DH.UPCOMING_OCCURRENCES_VIEW_ALL}
              className={classNames(classes.moreButton, s.moreButton)}
              priority={TextButtonPriority.primary}
              onClick={() => openOccurrencesModal()}
            >
              {t('recurring.viewAllDates', {count: allCount})}
            </TextButton>
          )}
        </div>
      )}
    </div>
  )
}
